import React, { PureComponent } from 'react'
import {
  Form,
  Input,
  Button,
  notification,
  Card,
  Row, Col, Modal, Icon
} from 'antd'
import _ from 'lodash'
import moment from 'moment'

import { apiUrl as apiurl } from '../../../settings'
import { connect } from 'react-redux'
import { getPushPathWrapper, getUrlParams } from '../../../routes'
import GetEachFormFields from '../../../components/_utils/appFormUtils'

import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { CountriesList, JournalList } from '../../journals/actions'
import {
  DesignationList,
  Countries,
  InputBox,
  MemberTypes,
  MemberPositions,
  MemberRatings,
  AuthorTitle,
  Genders, Discipline
} from '../../../components/_utils/appUtils'
import { addMember, getNextReviewerId, checkMemberEmails } from '../actions'
import { singleReviewer } from '../../reviewer/actions'
import { CustomCkEditor } from '../../../components/_utils/appUtils'
import { chooseEmailModalFxn } from '../../../components/_utils/appUtils'
import MentionInfo from '../../email/mentionInfo'

@Form.create()
class AddArticle extends PureComponent {

  state = {
    edit: false,
    journalListArr: [],
    memberImage: {},
    memberCV: {},
    fileKey: moment(),
    reviewerId: '',
    reviewerIdNumber: '',
    ckeditorKey: moment() + 1,
    reviewerFile: {},
    cvAndBrief: {},
    description: ''
  }

  constructor(props) {
    super(props)
  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      enterDate: moment(),
      memberType: '',
      journals: [],
      rating: '',
      position: '',
      department: '',
      title: '',
      areaOfInterest: '',
      //discipline: '',
      category: '',
      name: '',
      instituteAffiliatedWith: '',
      gender: '',
      address: '',
      designation: '',
      country: '',
      email: '',
      instituteWebsite: '',
      secondaryEmail: '',
      contactNo: '',
      otherDetails: '',
      description: ''
    })
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let { reviewerId, reviewerIdNumber, becomeReviewerId } = this.state

        chooseEmailModalFxn({
          callback: async (email) => {
            let fd = new FormData()
            valData.reviewerId = reviewerId
            // valData.status = 'accepted'
            valData.reviewerIdNumber = reviewerIdNumber
            valData.fromEmail = email
            valData.template = 'reviewerRegister'
            valData.description = this.state.description
            if (becomeReviewerId) {
              valData.becomeReviewerId = becomeReviewerId
            }

            let resp = await dispatch(checkMemberEmails(valData))
            if (resp && resp.success) {
              fd.append('obj', JSON.stringify(valData))
              fd.append('memberImage', this.state.memberImage)
              fd.append('memberCV', this.state.memberCV)
              let { success, message } = await dispatch(addMember(fd))

              if (success) {
                notification.success({
                  message: message
                })
                this.resetFormData()
                setTimeout(() => {
                  this.setState({ fileKey: moment(), ckeditorKey: moment() + 1 })
                  dispatch(getPushPathWrapper('member.addMember'))
                }, 300)

                this.loadReviewerId()
              }
            }
          }
        })
      }
    })
  }

  setFormValuesFxn = async (id) => {

    const { dispatch, form } = this.props
    let { error, data } = await dispatch(singleReviewer(id))
    if (data.reviewerFile != null && data.cvAndBrief != null) {
      this.setState({ memberImage: data.reviewerFile, memberCV: data.cvAndBrief })
    }
    // if (data.memberImage != null && data.memberCV != null) {
    //   this.setState({ memberImage: data.memberImage, memberCV: data.memberCV })
    // }
    if (error) {
      notification.error({
        message: 'Error Loading Data'
      })
    } else {
      if (data.status && data.status !== 'Accepted') {
        form.setFieldsValue({ ...data, instituteAffiliatedWith: data.institute })
        this.setState({ becomeReviewerId: data._id })
      } else {
        Modal.error({
          content: (
            <div>
              <h3>Reviewer already Approved</h3>
            </div>
          ),
          onOk: () => {
            dispatch(getPushPathWrapper('member.addMember'))
          },
          onCancel: () => {
            dispatch(getPushPathWrapper('member.addMember'))
          }
        })
      }
    }
  }

  componentDidMount() {
    this.loadJournalList()
    this.loadReviewerId()
    let data = getUrlParams('member.reviewer', this.props.pathname)
    // let data = getUrlParams('member.reviewer', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }


  loadJournalList = async () => {
    const { dispatch, form } = this.props
    let { data } = await JournalList()
    this.setState({ journalListArr: data })
    form.setFieldsValue({ enterDate: moment() })
  }


  loadReviewerId = async () => {
    const { dispatch } = this.props
    let resp = await dispatch(getNextReviewerId())
    this.setState({ reviewerIdNumber: resp.reviewerIdNumber, reviewerId: resp.reviewerId })
  }


  chooseDocument = (e) => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  render() {

    const { form: { getFieldDecorator, getFieldValue, setFieldsValue }, loading } = this.props
    const { edit, journalListArr } = this.state

    const formProps = {
      getFieldDecorator, getFieldValue, apiurl, loading
    }
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchema = {
      fields: [
        {
          label: 'Date of Enter',
          key: 'enterDate',
          required: true,
          placeholder: 'Date of Enter',
          type: 'date',
          disabled: true
        },
        {
          label: 'Member Id',
          customField: (
            <InputBox title={`Member Id`} required={true}>
              <Input className={'form-control'} value={this.state.reviewerId} disabled={true}
                     onChange={(e) => {
                       this.setState({ reviewerId: e.target.value })
                     }} />
            </InputBox>
          )
        },
        {
          label: 'Member Type',
          key: 'memberType',
          required: true,
          placeholder: 'Member Type',
          type: 'select',
          options: MemberTypes,
          onChange: (val) => {
            setFieldsValue({ memberType: val })
          }
        },
        {
          label: 'Journal of Interest',
          key: 'journals',
          required: true,
          showSearch: true,
          options: journalListArr,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          placeholder: 'Journal',
          type: 'select',
          mode: 'multiple',
          onChange: (val) => {
            setFieldsValue({ journals: val })
          }
        },
        {
          label: 'Member Position',
          key: 'position',
          placeholder: 'Member Position',
          type: 'select',
          hidden: !(getFieldValue('memberType') === 'Editorial Board'),
          required: (getFieldValue('memberType') === 'Editorial Board'),
          options: MemberPositions,
          onChange: (val) => {
            setFieldsValue({ position: val })
          }
        },
        {
          label: 'Rating',
          key: 'rating',
          required: true,
          placeholder: 'Rating',
          type: 'select',
          options: MemberRatings(),
          keyAccessor: x => x.value,
          valueAccessor: x => x.label,
          onChange: (val) => {
            setFieldsValue({ rating: val })
          }
        },
        {
          label: 'Discipline',
          key: 'category',
          required: true,
          placeholder: 'Discipline',
          options: Discipline,
          type: 'select',
          onChange: (val) => {
            setFieldsValue({ category: val })
          }
        },
        {
          label: 'Area Of Interest',
          key: 'areaOfInterest',
          required: true,
          placeholder: 'Area Of Interest'
        },
        {
          label: 'Title',
          key: 'title',
          required: true,
          options: AuthorTitle,
          placeholder: 'Title',
          type: 'select',
          onChange: (val) => {
            setFieldsValue({ title: val })
          }
        },
        {
          label: 'Department',
          key: 'department',
          required: true,
          placeholder: 'Department'

        },
        {
          label: 'Name',
          key: 'name',
          required: true,
          placeholder: 'Name'
        },
        {
          label: 'Institute Affiliated With',
          key: 'instituteAffiliatedWith',
          required: true,
          placeholder: 'Institute Affiliated With'
        },


        {
          label: 'Gender',
          key: 'gender',
          required: true,
          options: Genders,
          placeholder: 'Gender',
          type: 'select',
          onChange: (val) => {
            setFieldsValue({ gender: val })
          }
        },
        {
          label: 'Address',
          key: 'address',
          required: true,
          placeholder: 'Address'
        },
        {
          label: 'Designation',
          key: 'designation',
          required: true,
          placeholder: 'Designation',
          options: DesignationList,
          type: 'select',
          onChange: (val) => {
            setFieldsValue({ designation: val })
          }
        },
        {
          label: 'Other Designation',
          key: 'otherDesignation',
          required: getFieldValue('designation') == 'Others',
          hidden: getFieldValue('designation') !== 'Others',
          placeholder: 'Other Designation'
        },
        {
          label: 'Country',
          key: 'country',
          required: true,
          showSearch: true,
          options: Countries,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          placeholder: 'Country',
          type: 'select',
          onChange: (val) => {
            setFieldsValue({ country: val })
          }
        },

        {
          label: 'Primary Email',
          key: 'email',
          required: true,
          placeholder: 'Primary Email',
          type: 'email'
        },
        {
          label: 'Institute Website',
          key: 'institutionWebsite',
          placeholder: 'Institute Website'
        },
        {
          label: 'Secondary Email',
          key: 'secondaryEmail',
          placeholder: 'Secondary Email'
        },
        {
          label: 'Profile Image',
          customField: (
            <InputBox title={`Profile Image`} className={'rowFlex'}>
              <Input type={'file'} name={'memberImage'} id={'memberImage'}
                     className={'form-control'} key={this.state.fileKey}
                     onChange={(e) => {
                       this.chooseDocument(e)
                     }} />
              {this.state.memberImage && this.state.memberImage.path ?
                <a className={'linkBtn'} target={'_blank'} href={this.state.memberImage.path}>
                  <Icon type={'eye'} />
                </a> : null}
            </InputBox>

          )
        },
        {
          label: 'CV Attachment',
          customField: (
            <InputBox title={`CV Attachment`} className={'rowFlex'}>
              <Input type={'file'} name={'memberCV'} id={'memberCV'}
                     className={'form-control'} key={this.state.fileKey}
                     onChange={(e) => {
                       this.chooseDocument(e)
                     }} />
              {this.state.memberCV !== {} && this.state.memberCV.path ?
                <a className={'linkBtn'} target={'_blank'} href={this.state.memberCV.path}>
                  <Icon type={'eye'} />
                </a> : null}

            </InputBox>
          )
        },
        {
          label: 'Contact number',
          key: 'contactNo',
          placeholder: 'Contact number'
        },
        {
          label: 'Other Details (if any)',
          key: 'otherDetails',
          placeholder: 'Other Details (if any)',
          type: 'textArea',
          rows: 2,
          span: 24
        },
        // {
        //   label: 'Complete description',
        //   key: 'description',
        //   placeholder: 'Complete description',
        //   type: 'ckeditor',
        //   editorKey: this.state.ckeditorKey,
        //   rows: 2,
        //   span: 24
        // },
        {
          label: 'Profile description',
          key: 'description',
          // type: 'ckeditor',
          // editorKey: this.state.ckeditorKey,
          rows: 2,
          span: 24,
          customField: (
            <>
              <CustomCkEditor title={'Profile description'}
                              extraBox={(
                                <MentionInfo><a><Icon type={'info-circle'} /></a></MentionInfo>
                              )}
                //feeds={mentionsFeeds}
                              html={this.state.description}
                              onChange={(data) => {
                                this.setState({ description: data })
                              }}
              /></>)
        }
        // {
        //   label: 'Reviewer File',
        //   span: 5,
        //   //key: 'reviewerFile',
        //   customField: (
        //     this.state.reviewerFile !== {} && this.state.reviewerFile.path ?
        //       <a className={'linkBtn'} target={'_blank'} href={this.state.cvAndBrief.path}>
        //         View Profile Picture
        //       </a> : 'No Attachment for Profile Picture'
        //   )
        // },
        // {
        //   label: 'CV And Brief',
        //   span: 5,
        //   //key: 'cvAndBrief',
        //   customField: (
        //     this.state.cvAndBrief !== {} && this.state.cvAndBrief.path ?
        //       <a className={'linkBtn'} target={'_blank'} href={this.state.cvAndBrief.path}>
        //         View CV And Brief
        //       </a> : 'No Attachment for CV and Brief'
        //   )
        // }
      ]

    }


    return (
      <PageHeaderWrapper
        title={'Add Member'}>

        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'} noValidate={true}>
            <Row gutter={16} className={'wrapRow'}>
              {inputSchema.fields.map((item, key) => {
                return (
                  !item.hidden && <Col span={item.span ? item.span : 12} md={item.span ? item.span : 12} sm={12} xs={24}
                                       key={key}>
                    {item.customField ? item.customField :
                      <GetEachFormFields
                        item={item}
                        getFieldDecorator={getFieldDecorator}
                        formItemLayout={formItemLayout} />}
                  </Col>
                )
              })}
            </Row>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type='primary' htmlType='submit'>
                SUBMIT
              </Button>
            </Form.Item>

          </Form>


        </Card>

      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddArticle)
